var single_swiper;

// ── Mobile header: forward menu-click to legacy sidebar ──
// On panel pages, the same burger opens the profile sidebar instead of the site mega-menu
// so users don't see two competing burger buttons on mobile.
(function () {
  document.addEventListener("click", function (e) {
    var btn = e.target.closest && e.target.closest("[data-mh-menu]");
    if (!btn) return;
    e.preventDefault();
    var panelSide = document.querySelector(".aside-panel-warapper");
    if (panelSide) {
      panelSide.classList.toggle("active");
      var mask = document.querySelector(".mask-shadow");
      if (mask) mask.classList.toggle("active");
      return;
    }
    var side = document.querySelector(".mega-menu-site-responsive");
    if (side) side.classList.toggle("active");
  });
})();

// ── Gift page: country + amount switch + preview sync ──
(function () {
  var REGION_LABEL = { usa: "USA", tr: "TR", uk: "UK", de: "DE", ae: "AE", sa: "SA" };

  function syncPreview(root) {
    var active = root.querySelector(".gp__amounts:not([hidden]) input:checked");
    if (!active) return;
    var labelEl = root.querySelector("[data-selected-amount]");
    var priceEl = root.querySelector("[data-selected-price]");
    var regionEl = root.querySelector("[data-selected-region]");
    var region = root.querySelector('input[name="gp-region"]:checked');
    if (labelEl) labelEl.textContent = active.getAttribute("data-label") || "";
    if (priceEl) priceEl.textContent = active.getAttribute("data-price") || "";
    if (regionEl && region) regionEl.textContent = REGION_LABEL[region.value] || region.value.toUpperCase();
  }

  document.addEventListener("change", function (e) {
    var r = e.target;
    if (!r || r.type !== "radio") return;
    var root = r.closest(".gp");
    if (!root) return;

    // Country change → toggle amount panels + pick first
    if (r.name === "gp-region") {
      root.querySelectorAll(".gp__country").forEach(function (c) {
        c.classList.toggle("is-active", c.contains(r));
      });
      root.querySelectorAll(".gp__amounts").forEach(function (p) {
        p.hidden = p.getAttribute("data-amounts-for") !== r.value;
      });
    }

    // Amount change → toggle .is-active in its panel
    if (r.name && r.name.indexOf("gp-amount-") === 0) {
      var panel = r.closest(".gp__amounts");
      if (panel) {
        panel.querySelectorAll(".gp__amount").forEach(function (a) {
          a.classList.toggle("is-active", a.contains(r));
        });
      }
    }

    syncPreview(root);
  });
})();

// ── Add-account page: type picker + password eye ──
(function () {
  document.addEventListener("change", function (e) {
    var r = e.target;
    if (!r || r.type !== "radio" || r.name !== "acc-type") return;
    var group = r.closest(".add-acc__types");
    if (!group) return;
    group.querySelectorAll(".add-acc__type").forEach(function (t) {
      t.classList.toggle("is-active", t.contains(r));
    });
  });

  document.addEventListener("click", function (e) {
    var eye = e.target.closest && e.target.closest(".add-acc__eye");
    if (!eye) return;
    var input = eye.parentElement.querySelector('input');
    if (input) input.type = input.type === "password" ? "text" : "password";
  });
})();

// ── Receipt page: copy / password toggle / timer countdown ──
(function () {
  document.addEventListener("click", function (e) {
    // Copy creds / code
    var btn = e.target.closest && e.target.closest("[data-copy]");
    if (btn) {
      var row = btn.closest(".receipt-prod__cred, .receipt-prod__code");
      var src = row && row.querySelector("[data-copy-src]");
      if (!src) return;
      var secret = row.querySelector("[data-secret]");
      var text;
      if (secret && secret.getAttribute("data-mask") === "true") {
        var eye = row.querySelector("[data-secret-toggle]");
        text = eye && eye.getAttribute("data-secret-value");
      } else if (src.tagName === "INPUT" || src.tagName === "TEXTAREA") {
        text = src.value;
      } else {
        text = src.textContent.trim();
      }
      if (!text) return;
      try {
        navigator.clipboard.writeText(text);
      } catch (err) {
        var ta = document.createElement("textarea");
        ta.value = text;
        document.body.appendChild(ta);
        ta.select();
        document.execCommand("copy");
        ta.remove();
      }
      btn.classList.add("is-copied");
      setTimeout(function () { btn.classList.remove("is-copied"); }, 1600);
      return;
    }

    // Password show/hide
    var eyeBtn = e.target.closest && e.target.closest("[data-secret-toggle]");
    if (eyeBtn) {
      var row2 = eyeBtn.closest(".receipt-prod__cred");
      var sec = row2 && row2.querySelector("[data-secret]");
      if (!sec) return;
      var real = eyeBtn.getAttribute("data-secret-value") || "";
      var masked = sec.getAttribute("data-mask") === "true";
      sec.textContent = masked ? real : "••••••••••";
      sec.setAttribute("data-mask", masked ? "false" : "true");
    }
  }, false);

  // Countdown timers for pending products
  document.querySelectorAll(".receipt-prod[data-status='pending']").forEach(function (prod) {
    var mmEl = prod.querySelector("[data-timer-mm]");
    var ssEl = prod.querySelector("[data-timer-ss]");
    if (!mmEl || !ssEl) return;
    var total = parseInt(mmEl.textContent, 10) * 60 + parseInt(ssEl.textContent, 10);
    function tick() {
      if (total <= 0) return;
      total--;
      var m = Math.floor(total / 60);
      var s = total % 60;
      mmEl.textContent = m < 10 ? "0" + m : m;
      ssEl.textContent = s < 10 ? "0" + s : s;
    }
    setInterval(tick, 1000);
  });
})();

// ── Basket cart interactions (toggle / tabs / eye / qty / save) ─
(function () {
  document.addEventListener("click", function (e) {
    // Toggle account section
    var sum = e.target.closest && e.target.closest("[data-acc-toggle]");
    if (sum) {
      var acc = sum.closest(".basket-item__acc");
      if (acc) acc.classList.toggle("is-open");
      return;
    }

    // Password show/hide
    var eye = e.target.closest && e.target.closest(".basket-item__acc-eye");
    if (eye) {
      var input = eye.parentElement.querySelector('input');
      if (input) input.type = input.type === "password" ? "text" : "password";
      return;
    }

    // Save account info → badge + status update
    var save = e.target.closest && e.target.closest("[data-acc-save]");
    if (save) {
      var item = save.closest(".basket-item");
      if (!item) return;
      var acc2 = item.querySelector(".basket-item__acc");
      var badge = item.querySelector("[data-acc-badge]");
      var status = item.querySelector("[data-acc-status]");
      var mode = item.querySelector('.basket-item__acc-tab.is-active input');
      var selectedMode = mode ? mode.value : "have";
      acc2.classList.add("is-filled");
      if (badge) {
        badge.classList.add("is-done");
        badge.innerHTML = '<svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>تایید شد';
      }
      if (status) {
        if (selectedMode === "create") {
          status.textContent = "اکانت جدید توسط دیکاردو ساخته می‌شود";
        } else {
          var email = item.querySelector('input[type="email"]');
          status.textContent = email && email.value ? email.value : "اطلاعات اکانت ذخیره شد";
        }
      }
      acc2.classList.remove("is-open");
      return;
    }
  }, true);

  // Tab switch (have / create)
  document.addEventListener("change", function (e) {
    var radio = e.target;
    if (!radio || radio.type !== "radio" || !radio.name || radio.name.indexOf("acc-") !== 0) return;
    var acc = radio.closest(".basket-item__acc");
    if (!acc) return;
    acc.querySelectorAll(".basket-item__acc-tab").forEach(function (t) {
      var inp = t.querySelector('input');
      t.classList.toggle("is-active", inp === radio);
    });
    acc.querySelectorAll("[data-acc-panel]").forEach(function (p) {
      p.hidden = p.getAttribute("data-acc-panel") !== radio.value;
    });
  });
})();

// ── Cat Hero tab switcher (top-level, capture phase) ──────────
(function () {
  document.addEventListener("click", function (e) {
    var btn = e.target.closest && e.target.closest(".cat-hero__item");
    if (!btn) return;
    var hero = btn.closest(".cat-hero");
    if (!hero) return;
    var target = btn.getAttribute("data-cat-target");
    if (!target) return;
    hero.querySelectorAll(".cat-hero__item").forEach(function (b) {
      b.classList.remove("is-active");
      b.setAttribute("aria-selected", "false");
    });
    btn.classList.add("is-active");
    btn.setAttribute("aria-selected", "true");
    hero.querySelectorAll(".cat-hero__banner").forEach(function (p) {
      p.classList.toggle("is-active", p.getAttribute("data-cat-panel") === target);
    });
  }, true);
})();

// ── Theme toggle (bound before document.ready so it intercepts
//    any other handlers that might try to steal the click) ────
(function () {
  function toggleTheme() {
    var body = document.body;
    var current = body.getAttribute("data-theme") || "light";
    var next = current === "dark" ? "light" : "dark";
    body.setAttribute("data-theme", next);
    var switches = document.querySelectorAll(".site-header__bottom__theme-switch");
    for (var i = 0; i < switches.length; i++) {
      switches[i].setAttribute("data-current-theme", next);
    }
    var date = new Date();
    date.setTime(date.getTime() + 30 * 24 * 60 * 60 * 1000);
    var expires = "; expires=" + date.toGMTString() + "; path=/";
    document.cookie = "theme=" + next + expires;
    document.cookie = "locktheme=true" + expires;
  }

  document.addEventListener("click", function (e) {
    var t = e.target;
    if (!t) return;
    var el = t.closest ? t.closest(".sh-top__theme") : null;
    if (!el) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    e.stopPropagation();
    toggleTheme();
  }, true);

  // Expose for debugging / backend hook
  window.dicardoToggleTheme = toggleTheme;
})();

// ── Single page: variant info/warranty/faq popover ────────────────
(function () {
  var INFO_ICON     = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg>';
  var WARRANTY_ICON = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><polyline points="9 12 11 14 15 10"/></svg>';
  var FAQ_ICON      = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>';
  var TERMS_ICON    = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="9" y1="13" x2="15" y2="13"/><line x1="9" y1="17" x2="13" y2="17"/></svg>';

  var EYEBROW = {
    info: "توضیحات محصول",
    warranty: "شرایط گارانتی",
    faq: "سوالات متداول",
    terms: "شرایط و ضوابط"
  };

  // Group <p><strong>Q</strong></p><p>A</p> sequences into FAQ accordion items
  function buildFaqAccordion(frag) {
    var paragraphs = frag.querySelectorAll("p");
    if (!paragraphs.length) return frag;
    var list = document.createElement("div");
    list.className = "sp__popover-faq";
    // Single accordion-group name → native browsers (Chrome 120+, Safari 17.4+,
    // Firefox 123+) auto-close other items when one opens.
    var groupName = "sp-faq-" + Math.random().toString(36).slice(2, 8);
    var pending = null;
    paragraphs.forEach(function (p) {
      // A paragraph that is just a <strong> = a question
      var onlyStrong = p.children.length === 1 && p.children[0].tagName === "STRONG";
      if (onlyStrong) {
        if (pending) list.appendChild(pending);
        pending = document.createElement("details");
        pending.className = "sp__popover-faq-item";
        pending.setAttribute("name", groupName);
        var summary = document.createElement("summary");
        summary.className = "sp__popover-faq-q";
        summary.innerHTML =
          '<span class="sp__popover-faq-q-text">' + p.children[0].innerHTML + '</span>' +
          '<svg class="sp__popover-faq-q-chev" viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg>';
        pending.appendChild(summary);
      } else {
        if (pending) {
          var ans = document.createElement("div");
          ans.className = "sp__popover-faq-a";
          ans.innerHTML = p.innerHTML;
          pending.appendChild(ans);
          list.appendChild(pending);
          pending = null;
        }
      }
    });
    if (pending) list.appendChild(pending);

    // Fallback for browsers that don't support the `name` attribute on <details>:
    // close all other items when one opens.
    list.addEventListener("toggle", function (e) {
      if (!e.target || e.target.tagName !== "DETAILS" || !e.target.open) return;
      list.querySelectorAll("details[open]").forEach(function (d) {
        if (d !== e.target) d.removeAttribute("open");
      });
    }, true);

    // Open the first item by default
    var first = list.querySelector("details");
    if (first) first.setAttribute("open", "");
    return list;
  }

  function openPopover(target) {
    var tpl = document.querySelector('template[data-popover-id="' + target + '"]');
    var popover = document.querySelector('[data-variant-popover]');
    if (!tpl || !popover) return;

    var type = tpl.getAttribute("data-popover-type") || "info";
    var heading = tpl.getAttribute("data-popover-heading") || "";

    var titleEl   = popover.querySelector("[data-popover-title]");
    var icoEl     = popover.querySelector("[data-popover-ico]");
    var bodyEl    = popover.querySelector("[data-popover-body]");
    var eyebrowEl = popover.querySelector("[data-popover-eyebrow]");

    popover.setAttribute("data-type", type);
    if (titleEl) titleEl.textContent = heading;
    if (eyebrowEl) eyebrowEl.textContent = EYEBROW[type] || EYEBROW.info;
    if (icoEl) {
      icoEl.setAttribute("data-type", type);
      icoEl.innerHTML =
        type === "warranty" ? WARRANTY_ICON :
        type === "faq"      ? FAQ_ICON      :
        type === "terms"    ? TERMS_ICON    :
                              INFO_ICON;
    }
    if (bodyEl) {
      bodyEl.innerHTML = "";
      var frag = tpl.content.cloneNode(true);
      if (type === "faq") {
        bodyEl.appendChild(buildFaqAccordion(frag));
      } else {
        bodyEl.appendChild(frag);
      }
    }

    popover.hidden = false;
    document.body.style.overflow = "hidden";
  }

  function closePopover() {
    var popover = document.querySelector("[data-variant-popover]");
    if (!popover) return;
    popover.hidden = true;
    document.body.style.overflow = "";
  }

  document.addEventListener("click", function (e) {
    if (!e.target || !e.target.closest) return;

    var trigger = e.target.closest("[data-variant-info]");
    if (trigger) {
      e.preventDefault();
      e.stopPropagation();
      var target = trigger.getAttribute("data-target");
      if (target) openPopover(target);
      return;
    }

    if (e.target.closest("[data-popover-close]")) {
      closePopover();
    }
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") closePopover();
  });
})();

// ── License cards: toggle / copy / show password ─────────────
(function () {
  document.addEventListener("click", function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    // Toggle card body (only via head or toggle button, ignore inner controls)
    if (t.closest(".license__icon-btn, .license__btn, .license__action, input")) {
      // let these handle their own events below
    } else {
      var toggleBtn = t.closest("[data-license-toggle], .license__card-head");
      if (toggleBtn) {
        var card = toggleBtn.closest(".license__card");
        if (card) {
          var isOpen = card.classList.toggle("is-open");
          var btn = card.querySelector("[data-license-toggle]");
          if (btn) btn.setAttribute("aria-expanded", isOpen ? "true" : "false");
          return;
        }
      }
    }

    // Copy to clipboard
    var copyBtn = t.closest("[data-copy]");
    if (copyBtn) {
      e.preventDefault();
      var val = copyBtn.getAttribute("data-copy");
      if (navigator.clipboard) navigator.clipboard.writeText(val);
      var original = copyBtn.innerHTML;
      copyBtn.innerHTML = '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>';
      setTimeout(function () { copyBtn.innerHTML = original; }, 1200);
      return;
    }

    // Show/hide password
    var eye = t.closest("[data-toggle-secret]");
    if (eye) {
      e.preventDefault();
      var wrap = eye.closest(".license__cred-value");
      var input = wrap && wrap.querySelector("input[data-secret]");
      if (!input) return;
      input.type = input.type === "password" ? "text" : "password";
    }
  });
})();

// ── Profile settings: tab switcher ────────────────────────────
(function () {
  document.addEventListener("click", function (e) {
    var btn = e.target && e.target.closest ? e.target.closest(".profile__tab[data-tab]") : null;
    if (!btn) return;
    var root = btn.closest(".profile");
    if (!root) return;
    var tab = btn.getAttribute("data-tab");

    root.querySelectorAll(".profile__tab").forEach(function (t) {
      t.classList.toggle("is-active", t === btn);
    });
    root.querySelectorAll("[data-tab-panel]").forEach(function (p) {
      p.classList.toggle("is-active", p.getAttribute("data-tab-panel") === tab);
    });
  });
})();

// ── Panel sidebar: mark active link based on current page ────
(function () {
  var path = (location.pathname.split("/").pop() || "").toLowerCase();
  var map = {
    "panel-dashboard.html"       : "dashboard",
    "panel-my-buy.html"          : "my-buy",
    "panel-wallet.html"          : "wallet",
    "panel-favorites.html"       : "favorites",
    "panel-earn.html"            : "earn",
    "panel-my-accounts.html"     : "my-accounts",
    "panel-tickets.html"         : "tickets",
    "panel-ticket.html"          : "tickets",
    "panel-new-ticket.html"      : "tickets",
    "panel-profile-setting.html" : "profile",
    "panel-add-account.html"     : "my-accounts",
    "panel-license.html"         : "license",
    "panel-extra.html"           : "settings",
  };
  var key = map[path];
  if (!key) return;
  document.querySelectorAll("[data-panel-link]").forEach(function (el) {
    if (el.getAttribute("data-panel-link") === key) el.classList.add("is-active");
    else el.classList.remove("is-active");
  });
})();

// ── Floating Contact Widget (FAB) ─────────────────────────────
// Bound at top level with capture-phase listener so it can't be
// intercepted by any other delegated handler.
(function () {
  // Lift the floating contact widget to <body> so no ancestor containing-block
  // (transform, filter, contain) can trap it. No position/coord JS — the CSS
  // `position: fixed; bottom; left` does the work.
  function liftFab() {
    var fab = document.querySelector(".fab-contact");
    if (fab && fab.parentNode !== document.body) {
      document.body.appendChild(fab);
      fab.setAttribute("data-fab-lifted", "1");
    }
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", liftFab);
  } else {
    liftFab();
  }

  document.addEventListener("click", function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    var toggle = t.closest(".fab-contact__toggle");
    if (toggle) {
      e.preventDefault();
      e.stopImmediatePropagation();
      e.stopPropagation();
      var fab = toggle.closest(".fab-contact");
      if (!fab) return;
      var isOpen = fab.classList.toggle("is-open");
      toggle.setAttribute("aria-expanded", isOpen ? "true" : "false");
      return;
    }

    // Close when clicking outside an open FAB
    var open = document.querySelector(".fab-contact.is-open");
    if (open && !t.closest(".fab-contact")) {
      open.classList.remove("is-open");
      var tgl = open.querySelector(".fab-contact__toggle");
      if (tgl) tgl.setAttribute("aria-expanded", "false");
    }
  }, true);
})();

$(document).ready(() => {
  $('a[href="#"]').click(function (e) {
    e.preventDefault();
  });

  new Swiper(".top-product__responsive", {
    lazy: true,
    loop: true,
    slidesPerView: 1.1,
    spaceBetween: 12,
    centeredSlides: true,
    autoplay: { delay: 3500, disableOnInteraction: false },
    speed: 650,
    pagination: {
      el: ".top-product__responsive-pagination",
      clickable: true,
      dynamicBullets: false,
    },
    breakpoints: {
      480: { slidesPerView: 1.15, spaceBetween: 14 },
    },
  });

  /* ─── Top Product hero slider (desktop) ────────────────────────
     Driven from data-attributes so backend can override:
       <div class="top-product__display" data-top-product data-interval="10000">
         <div class="top-product__display__slide" data-index="0">…</div>
       </div>
       <button class="top-product__orbit-icon" data-slide="0">…</button>
  */
  $("[data-top-product]").each(function () {
    var $display = $(this);
    var $slides = $display.find(".top-product__display__slide");
    var $icons = $(".top-product__orbit-icon");
    var $progressBar = $display.find(".top-product__display__progress-bar");
    var total = $slides.length;
    if (!total) return;

    var interval = parseInt($display.attr("data-interval"), 10) || 10000;
    var current = 0;
    var timer;

    function goTo(index) {
      $slides.removeClass("is-active");
      $icons.removeClass("is-active");
      $slides.eq(index).addClass("is-active");
      $icons.filter('[data-slide="' + index + '"]').addClass("is-active");
      current = index;
      resetProgress();
    }

    function next() {
      goTo((current + 1) % total);
    }

    function resetProgress() {
      if ($progressBar.length) {
        $progressBar.css({ transition: "none", width: "0%" });
        setTimeout(function () {
          $progressBar.css({
            transition: "width " + interval + "ms linear",
            width: "100%",
          });
        }, 50);
      }
      clearInterval(timer);
      timer = setInterval(next, interval);
    }

    $icons.on("click", function () {
      goTo(parseInt($(this).attr("data-slide"), 10) || 0);
    });

    goTo(0);
  });
  // new Swiper('.category__swiper',{
  //     slidesPerView: 3,
  //     spaceBetween: 30,
  //     allowTouchMove: false,
  //     breakpoints:{
  //         992:{
  //             slidesPerView: 3,
  //         },
  //         768:{
  //             slidesPerView: 2.2,
  //             allowTouchMove: true,
  //         },
  //         576:{
  //             slidesPerView: 2.2,
  //             allowTouchMove: true,
  //         }
  //     }
  // });
  new Swiper(".top-product__center", {
    slidesPerView: 1,
    spaceBetween: 15,
    autoplay: {
      delay: 3000,
    },
    navigation: {
      nextEl: ".top-product__center__button-next",
      prevEl: ".top-product__center__button-prev",
    },
  });
  new Swiper(".feautures__items-swiper", {
    slidesPerView: "auto",
    spaceBetween: 13,
    freeMode: 1,
    lazy: true,
    autoplay: {
      delay: 3000,
    },
    breakpoints: {
      768: {
        autoplay: false,
      },
    },
  });

  // (Legacy swiper init retained below — see overrides for mobile)
  new Swiper(".product__content-swiper", {
    slidesPerView: 2.3,
    spaceBetween: 10,
    lazy: true,

    navigation: {
      nextEl: ".product__nav--next",
      prevEl: ".product__nav--prev",
    },
    breakpoints: {
      992: { slidesPerView: 4, spaceBetween: 26 },
      768: { slidesPerView: 3, spaceBetween: 22 },
      576: { slidesPerView: 2.8, spaceBetween: 14 },
      420: { slidesPerView: 2.4, spaceBetween: 12 },
    },
  });

  new Swiper(".discount__content-swiper", {
    slidesPerView: 2.1,
    spaceBetween: 10,
    lazy: true,
    navigation: {
      nextEl: ".discount__nav--next",
      prevEl: ".discount__nav--prev",
    },
    breakpoints: {
      1200: { slidesPerView: 6, spaceBetween: 16 },
      992:  { slidesPerView: 5, spaceBetween: 14 },
      768:  { slidesPerView: 4, spaceBetween: 14 },
      576:  { slidesPerView: 3, spaceBetween: 12 },
      420:  { slidesPerView: 2.4, spaceBetween: 10 },
    },
  });

  new Swiper(".have_time__content-swiper", {
    slidesPerView: 1,
    lazy: true,
    loop: true,
    breakpoints: {
      1200: {
        slidesPerView: 1,
      },
      992: {
        slidesPerView: 1,
      },
      768: {
        slidesPerView: 1,
        spaceBetween: 20,
      },
      576: {
        slidesPerView: 1,
        spaceBetween: 20,
      },
      380: {
        slidesPerView: 1,
        spaceBetween: 0,
      },
    },

    navigation: {
      nextEl: ".have_time__nav--next",
      prevEl: ".have_time__nav--prev",
    },
  });

  // 2021/09/16 start
  new Swiper(".product-slider__left-swiper", {
    slidesPerView: 1.5,
    spaceBetween: 15,
    lazy: true,
    pagination: {
      el: ".product-slider__right__pagi .swiper-pagination",
      type: "bullets",
      clickable: 1,
    },
    breakpoints: {
      1200: {
        slidesPerView: 5,
      },
      992: {
        slidesPerView: 4,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
      576: {
        slidesPerView: 2,
        spaceBetween: 15,
      },
      380: {
        slidesPerView: 2,
        spaceBetween: 15,
      },
    },
  });
  // 2021/09/16 end

  new Swiper(".journal__content-swiper", {
    slidesPerView: 1.4,
    lazy: true,
    breakpoints: {
      1200: { slidesPerView: 3.8 },
      992:  { slidesPerView: 3.2 },
      768:  { slidesPerView: 2.6 },
      576:  { slidesPerView: 2.2 },
    },
  });

  new Swiper(".journal__swiper", {
    lazy: true,
    slidesPerView: 1.15,
    spaceBetween: 16,
    navigation: {
      nextEl: ".journal__nav--next",
      prevEl: ".journal__nav--prev",
    },
    breakpoints: {
      1200: { slidesPerView: 4, spaceBetween: 20 },
      992:  { slidesPerView: 3, spaceBetween: 18 },
      768:  { slidesPerView: 2.4, spaceBetween: 16 },
      576:  { slidesPerView: 1.6, spaceBetween: 14 },
    },
  });

  new Swiper(".vip-acc__swiper", {
    slidesPerView: 1,
    spaceBetween: 20,
    lazy: true,
    breakpoints: {
      450: {
        slidesPerView: 1,
        spaceBetween: 20,
      },
      480: {
        slidesPerView: 1.2,
        spaceBetween: 20,
      },
      576: {
        slidesPerView: 1.5,
        spaceBetween: 20,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      992: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      1200: {
        slidesPerView: 2,
        spaceBetween: 40,
      },
    },
  });

  new Swiper(".journal__content-swiper--blog-single", {
    slidesPerView: 1,
    spaceBetween: 20,
    lazy: true,
    breakpoints: {
      450: {
        slidesPerView: 1,
        spaceBetween: 20,
      },
      480: {
        slidesPerView: 1.2,
        spaceBetween: 20,
      },
      576: {
        slidesPerView: 1.5,
        spaceBetween: 20,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      992: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      1200: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
    },
  });

  new Swiper(".single-gallery__swiper", {
    slidesPerView: 1,
    spaceBetween: 30,
    lazy: true,
    breakpoints: {
      1200: {
        slidesPerView: 4,
      },
      992: {
        slidesPerView: 3.3,
      },
      768: {
        slidesPerView: 2.5,
      },
      576: {
        slidesPerView: 1.9,
        spaceBetween: 30,
      },
      450: {
        slidesPerView: 1.5,
      },
      320: {
        slidesPerView: 1.3,
        spaceBetween: 15,
      },
    },
  });

  new Swiper(".rel-ai__swiper", {
    slidesPerView: 2.15,
    spaceBetween: 10,
    lazy: true,
    navigation: {
      nextEl: ".rel-ai__nav--next",
      prevEl: ".rel-ai__nav--prev",
    },
    breakpoints: {
      1400: { slidesPerView: 5, spaceBetween: 18 },
      1200: { slidesPerView: 4, spaceBetween: 16 },
      992:  { slidesPerView: 3.2, spaceBetween: 14 },
      640:  { slidesPerView: 2.6, spaceBetween: 12 },
      480:  { slidesPerView: 2.3, spaceBetween: 10 },
    },
  });

  new Swiper(".related-single__swiper", {
    slidesPerView: 1,
    spaceBetween: 30,
    lazy: true,
    navigation: {
      nextEl: ".product__nav--next",
      prevEl: ".product__nav--prev",
    },
    breakpoints: {
      992: {
        slidesPerView: 4,
        spaceBetween: 30,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
      576: {
        slidesPerView: 2,
        spaceBetween: 30,
      },
      450: {
        slidesPerView: 2,
        spaceBetween: 30,
      },
      300: {
        slidesPerView: 1.45,
        spaceBetween: 30,
      },
    },
  });

  new Swiper(".slider-blog__swiper", {
    slidesPerView: 1,
    spaceBetween: 21,
    centeredSlides: true,
    lazy: true,
  });
  new Swiper(".landing__content__swiper", {
    slidesPerView: 7,
    spaceBetween: 12,
    lazy: true,
    navigation: {
      nextEl: ".product__nav--next",
      prevEl: ".product__nav--prev",
    },
    breakpoints: {
      // 992: {
      //     slidesPerView: 7,
      // },
      768: {
        slidesPerView: 6,
      },
      576: {
        slidesPerView: 4,
      },
      450: {
        slidesPerView: 3,
      },
      300: {
        slidesPerView: 2.25,
      },
      100: {
        slidesPerView: 2,
      },
    },
  });

  $(document).ready(function () {
    $('*[data-rate="1"]').click(function () {
      $(this).find("i").removeClass("dicardo-star-o").addClass("dicardo-star");
    });
    $('*[data-rate="2"]').click(function () {
      $('*[data-rate="1"]')
        .find("i")
        .removeClass("dicardo-star-o")
        .addClass("dicardo-star");
      $('*[data-rate="2"]')
        .find("i")
        .removeClass("dicardo-star-o")
        .addClass("dicardo-star");
    });
    $('*[data-rate="3"]').click(function () {
      $('*[data-rate="1"]')
        .find("i")
        .removeClass("dicardo-star-o")
        .addClass("dicardo-star");
      $('*[data-rate="2"]')
        .find("i")
        .removeClass("dicardo-star-o")
        .addClass("dicardo-star");
      $('*[data-rate="3"]')
        .find("i")
        .removeClass("dicardo-star-o")
        .addClass("dicardo-star");
    });
    $('*[data-rate="4"]').click(function () {
      $('*[data-rate="1"]')
        .find("i")
        .removeClass("dicardo-star-o")
        .addClass("dicardo-star");
      $('*[data-rate="2"]')
        .find("i")
        .removeClass("dicardo-star-o")
        .addClass("dicardo-star");
      $('*[data-rate="3"]')
        .find("i")
        .removeClass("dicardo-star-o")
        .addClass("dicardo-star");
      $('*[data-rate="4"]')
        .find("i")
        .removeClass("dicardo-star-o")
        .addClass("dicardo-star");
    });
    $('*[data-rate="5"]').click(function () {
      $('*[data-rate="1"]')
        .find("i")
        .removeClass("dicardo-star-o")
        .addClass("dicardo-star");
      $('*[data-rate="2"]')
        .find("i")
        .removeClass("dicardo-star-o")
        .addClass("dicardo-star");
      $('*[data-rate="3"]')
        .find("i")
        .removeClass("dicardo-star-o")
        .addClass("dicardo-star");
      $('*[data-rate="4"]')
        .find("i")
        .removeClass("dicardo-star-o")
        .addClass("dicardo-star");
      $('*[data-rate="5"]')
        .find("i")
        .removeClass("dicardo-star-o")
        .addClass("dicardo-star");
    });
  });
  /* ─── AI Time-Limited Deals ──────────────────────────────────
     Backend can override the end timestamp via data-end-in (seconds
     remaining) or data-end-at (ISO timestamp) on [data-ai-deals-countdown].
  */
  new Swiper(".ai-deals__swiper", {
    lazy: true,
    slidesPerView: 1.8,
    spaceBetween: 10,
    navigation: {
      nextEl: ".ai-deals__nav--next",
      prevEl: ".ai-deals__nav--prev",
    },
    breakpoints: {
      1200: { slidesPerView: 5, spaceBetween: 18 },
      992:  { slidesPerView: 4, spaceBetween: 16 },
      768:  { slidesPerView: 3, spaceBetween: 14 },
      576:  { slidesPerView: 2.4, spaceBetween: 12 },
      420:  { slidesPerView: 2.1, spaceBetween: 10 },
    },
  });

  $("[data-ai-deals-countdown]").each(function () {
    var $el = $(this);
    var endAt = $el.data("end-at");
    var endTime;
    if (endAt) {
      endTime = new Date(endAt).getTime();
    } else {
      var secs = parseInt($el.data("end-in"), 10) || 86400;
      endTime = Date.now() + secs * 1000;
    }

    var $hours   = $el.find('[data-unit="hours"]');
    var $minutes = $el.find('[data-unit="minutes"]');
    var $seconds = $el.find('[data-unit="seconds"]');

    function pad(n) { return n < 10 ? "0" + n : "" + n; }

    function tick() {
      var diff = Math.max(0, endTime - Date.now());
      var totalHours = Math.floor(diff / 3600000);
      var mins = Math.floor((diff % 3600000) / 60000);
      var secs = Math.floor((diff % 60000) / 1000);
      $hours.text(pad(totalHours));
      $minutes.text(pad(mins));
      $seconds.text(pad(secs));
      if (diff <= 0) clearInterval(timer);
    }

    tick();
    var timer = setInterval(tick, 1000);
  });

  document.querySelectorAll(".ai-news__swiper").forEach(function(el){
    var scope = el.closest(".ai-news");
    new Swiper(el, {
      lazy: true,
      loop: true,
      slidesPerView: 1.15,
      spaceBetween: 10,
      navigation: {
        nextEl: scope ? scope.querySelector(".ai-news__nav--next") : ".ai-news__nav--next",
        prevEl: scope ? scope.querySelector(".ai-news__nav--prev") : ".ai-news__nav--prev",
      },
      breakpoints: {
        1200: { slidesPerView: 3, spaceBetween: 20 },
        992:  { slidesPerView: 3, spaceBetween: 18 },
        768:  { slidesPerView: 2, spaceBetween: 16 },
        576:  { slidesPerView: 1.4, spaceBetween: 12 },
      },
    });
  });

  const new_onvan = new Swiper(".newonvan__content-swiper", {
    lazy: true,
    loop: true,
    slidesPerView: 1.6,
    spaceBetween: 10,
    navigation: {
      nextEl: ".newonvan__nav--next",
      prevEl: ".newonvan__nav--prev",
    },
    breakpoints: {
      1400: { slidesPerView: 5, spaceBetween: 20 },
      1200: { slidesPerView: 4, spaceBetween: 18 },
      992:  { slidesPerView: 4, spaceBetween: 16 },
      768:  { slidesPerView: 3, spaceBetween: 14 },
      576:  { slidesPerView: 2.2, spaceBetween: 12 },
      420:  { slidesPerView: 1.8, spaceBetween: 10 },
    },
  });
  //timer page tournament:

  $("[data-countdown]").each((i, e) => {
    var d = new Date();
    var n = d.getSeconds();
    var date = $(e).data("countdown");
    $(e).countdown(date, function (event) {
      $(this).html(
        event.strftime(`
            <div class="div-total">
                 <div class="div"><span>%M</span><span>دقیقه</span></div><span>:</span>
                 <div class="div"><span>%H</span><span>ساعت</span></div><span>:</span>
                 <div class="div"><span>%D</span><span>روز</span></div>

            </div>

                 `)
      );
    });
  });

  //

  function countDowns() {
    var countDownDate = 1200;

    // Update the count down every 1 second
    var x = setInterval(function () {
      // Get today's date and time
      var now = new Date().getTime();

      // Find the distance between now and the count down date
      var distance = countDownDate;

      // Time calculations for days, hours, minutes and seconds
      var days = Math.floor(distance / (1000 * 60 * 60 * 24));
      var hours = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);

      $(".login__footer-item .time .time__minutes").text(minutes);
      $(".login__footer-item .time .time__second").text(seconds);
    }, 1000);
  }

  if ($(".login__footer-item .time").length) {
    countDowns();
  }

  $(".my-buy__info  .item--show").on("click", function () {
    if ($(this).parent("tr").next(".item-drop-down").length) {
      $(this).parent("tr").next(".item-drop-down").find("td").slideToggle(300);
      $(this).toggleClass("active");
    }
  });
  $(".mobile_table__body__list a.operate").on("click", function (e) {
    e.preventDefault();
    if (
      $(this)
        .parents(".mobile_table__body")
        .siblings(".mobile_table__footer")
        .find(".item-drop-down").length
    ) {
      $(this)
        .parents(".mobile_table__body")
        .next(".mobile_table__footer")
        .find(".item-drop-down")
        .slideToggle(300);
      $(this).toggleClass("active");
    }
  });
  $(".panel-license__content__label_input i").on("click", function () {
    const inputField = $(this).siblings("input");
    $(this).parent().addClass('active');
    const type = inputField.attr("type") === "password" ? "text" : "password";
    inputField.attr("type", type);
  });
  $(".panel-license__content__label a").on("click", function (e) {
    e.preventDefault();
    const inputValue = $(this)
      .siblings(".panel-license__content__label_input")
      .find("input")
      .val();
    navigator.clipboard.writeText(inputValue).then(function () {
      alert("مقدار کپی شد!");
    });
  });
  $(".panel-license__content__label_input a").on("click", function (e) {
    e.preventDefault();
    const inputValue = $(this)
      .parents(".panel-license__content__label_input")
      .find("input")
      .val();
    navigator.clipboard.writeText(inputValue).then(function () {
      alert("مقدار کپی شد!");
    });
  });
  $(document).on("click", ".panel-license__close a", function (e) {
    e.preventDefault();
    $(this).parents(".item-drop-down").find("td").slideUp(300);
    $(".mobile_table__footer__list a.operate").removeClass("active");
    $(".my-buy__info  .item--show").removeClass("active");
  });
  $(document).on(
    "click",
    ".mobile_table__footer .panel-license__close a",
    function (e) {
      e.preventDefault();
      $(this).parents(".item-drop-down").slideUp(300);
      $(".mobile_table__footer__list a.operate").removeClass("active");
      $(".my-buy__info  .item--show").removeClass("active");
    }
  );
  $(".mobile_table__footer__list a.operate-license").on("click", function (e) {
    e.preventDefault();
    if (
      $(this)
        .parents(".mobile_table__body")
        .next(".mobile_table__footer")
        .find(".item-drop-down").length
    ) {
      $(this)
        .parents(".mobile_table__body")
        .next(".mobile_table__footer")
        .find(".item-drop-down")
        .slideToggle(300);
      $(this).toggleClass("active");
    }
  });
  $(".my-buy__info  .item--show a").on("click", function (e) {
    e.preventDefault();
  });

  $(".cart--my-buy__more a").on("click", function (e) {
    e.preventDefault();
    if (
      $(this).parent(".cart--my-buy__more").next(".cart--my-buy__footer").length
    ) {
      let $cartFooter = $(this)
        .parent(".cart--my-buy__more")
        .next(".cart--my-buy__footer");
      $cartFooter.slideToggle();
      $(this).toggleClass("active");
    }
  });

  $(".cart .more-table ul.status > li.action a").on("click", function (e) {
    e.preventDefault();
    if ($(this).parents(".more-table").next(".cart--my-buy__footer").length) {
      let $cartFooter = $(this)
        .parents(".more-table")
        .next(".cart--my-buy__footer");
      $cartFooter.slideToggle();
      $(this).toggleClass("active");
    }
  });

  $(document).ready(function () {
    const $items = $(".my-buy__top-item").children();
    console.log($items);
    if ($items.length % 2 !== 0) {
      $items.last().addClass("full-width");
    }
  });

  //////// 08/oct/2021
  $(document).on("click", ".license-key i", function (e) {
    e.preventDefault();
    $(this)
      .parent()
      .removeClass("license-key--dont-show")
      .html($(this).parent().data("license"));
  });

  $(document).on(
    "click",
    ".license-key:not(.license-key--dont-show)",
    function (e) {
      e.preventDefault();
      copyToClipboard($(this));
    }
  );
  //////// 08/oct/2021

  $(".information__close").one("click", function () {
    $(this).parent().slideUp(300);
  });

  if ($(".input").length) {
    $(".input [required]").each(function (index, el) {
      $(el).parent(".input").addClass("required");
    });
  }

  /* body event */
  $(document).on("click", function (e) {
    if (!$(e.target).closest(".site-header__bottom-cat").length) {
      $(".site-header__bottom-cat").removeClass("active");
    }
    if (!$(e.target).closest(".site-header__bottom-search").length) {
      $(".site-header__bottom-search").removeClass("active");
      $(".site-header__bottom-search button").removeClass("active");
    }
  });

  var search_slider = new Swiper(".swiper-ajax-product", {
    slidesPerView: 4.5,
    spaceBetween: 14,
    lazy: true,
  });

  // newwwwwwwwwwwwwwwww start
  $(".ajax-search__close").on("click", function () {
    $(this).closest(".site-header__bottom-search").removeClass("active");
  });

  $("[data-modal]").on("click", function () {
    let modal = $(this).data("modal");
    $(`[data-modal-target=${modal}]`).addClass("active");
  });

  $("[data-modal-close]").on("click", function () {
    $(this).closest(".modal").removeClass("active");
  });

  $(".modal__content__search input").on("keyup", function () {
    let val = $(this).val();
    $(this)
      .closest(".modal__content")
      .find(".modal__content__radio__item ul li span:last-child")
      .each(function () {
        if ($(this).text().toLowerCase().search(val.toLowerCase()) > -1) {
          $(this)
            .closest(".modal__content__radio__item")
            .removeClass("no-result");
        } else {
          $(this).closest(".modal__content__radio__item").addClass("no-result");
        }
      });
  });

  // newwwwwwwwwwwwwwwww end

  $(".site-header__bottom-search input").on("click", function (e) {
    if ($(".swiper-ajax-product").length) search_slider.update();
    $(this).parent().addClass("active");
    $(this).siblings("button").addClass("active");
  });

  $(".site-header__bottom-cat").on("click", function (e) {
    $(this).toggleClass("active");
  });

  $(
    ".site-header__bottom .site-header__bottom-cat .megamenu__tabs .item"
  ).hover(function () {
    $(this).addClass("active").siblings(".item").removeClass("active");
  });

  $(".megamenu").on("click", function (e) {
    e.stopPropagation();
  });

  $(".panel-menu").on("click", function () {
    $(".aside-panel-warapper").addClass("active");
    $(".mask-shadow").addClass("active");
  });

  $(".cart-info__close").on("click", function () {
    $(".aside-cart").removeClass("active");
  });

  $(".recent-ticket-btn").on("click", function () {
    $(".aside-ticket__recent-list").toggleClass("active");
    $(".close-recent-ticket").addClass("active");
  });

  $(".cart-factor").on("click", function () {
    $(".aside-cart").addClass("active");
  });

  $(".close-recent-ticket").on("click", function () {
    $(".aside-ticket__recent-list").removeClass("active");
    $(this).removeClass("active");
  });

  $(".aside-panel__close").on("click", function () {
    $(".aside-panel-warapper").removeClass("active");
    $(".mask-shadow").removeClass("active");
  });

  $(".notification__close").on("click", function () {
    $(this).parent().slideUp(300);
  });

  $(".faq__item-ask").on("click", function () {
    $(this)
      .parents(".faq__item")
      .siblings()
      .find(".faq__item-question")
      .slideUp(300);
    $(this).parents(".faq__item").siblings().removeClass("active");
    if ($(this).parent().hasClass("active")) {
      $(this).parents(".faq__item").removeClass("active");
      $(this).siblings(".faq__item-question").slideUp(300);
    } else {
      $(this).parents(".faq__item").addClass("active");
      $(this).siblings(".faq__item-question").slideDown(300);
    }
  });

  $(".faq_content__item-ask").on("click", function () {
    $(this)
      .parents(".faq_content__item")
      .siblings()
      .find(".faq_content__item-question")
      .slideUp(300);
    $(this).parents(".faq_content__item").siblings().removeClass("active");
    if ($(this).parent().hasClass("active")) {
      $(this).parents(".faq_content__item").removeClass("active");
      $(this).siblings(".faq_content__item-question").slideUp(300);
    } else {
      $(this).parents(".faq_content__item").addClass("active");
      $(this).siblings(".faq_content__item-question").slideDown(300);
    }
  });

  $(".select-box").selectpicker();
  $(".new-ticket__top-item select").selectpicker();
  $(".product__header-sort select").selectpicker();
  $(".cat-header__sort select").selectpicker();
  $(".article-blog__header-sort select").selectpicker();

  if ($(".pre-order").length) {
    $(".pre-order__wrapper").tilt({
      maxGlare: 0.2,
      perspective: 1000,
      axis: "y",
      scale: 1.02,
    });
  }

  if ($(".category").length) {
    $(".category__row__larg__item , .category__row__small__item").tilt({
      maxGlare: 0.2,
      perspective: 1000,
      scale: 1.02,
    });
  }

  $(".count-product__item--plus").on("click", function () {
    let el = $(this).siblings(".count-product__count");
    let count = parseInt(el.val());
    count++;
    el.val(count);
  });

  $(".count-product__item--minus").on("click", function () {
    let el = $(this).siblings(".count-product__count");
    let count = parseInt(el.val());
    if (count > 1) {
      count--;
    }
    el.val(count);
  });

  // if ($('.site-footer').length) {
  //     // drag-button-footer
  //     dragElement(document.getElementById("mydiv"));

  //     function dragElement(elmnt) {
  //         var pos1 = 0, pos3 = 0;
  //         if (document.getElementById(elmnt.id + "header")) {
  //             /* if present, the header is where you move the DIV from:*/
  //             document.getElementById(elmnt.id + "header").onmousedown = dragMouseDown;
  //         } else {
  //             /* otherwise, move the DIV from anywhere inside the DIV:*/
  //             elmnt.onmousedown = dragMouseDown;
  //         }

  //         function dragMouseDown(e) {
  //             e = e || window.event;
  //             e.preventDefault();
  //             // get the mouse cursor position at startup:
  //             pos3 = e.clientX;
  //             document.onmouseup = closeDragElement;
  //             // call a function whenever the cursor moves:
  //             document.onmousemove = elementDrag;
  //         }

  //         function elementDrag(e) {
  //             e = e || window.event;
  //             e.preventDefault();
  //             // calculate the new cursor position:
  //             if (e.clientX <= 325) {
  //                 $('#mydiv').addClass('d-none');
  //                 console.log(123);
  //                 $('.discount-footer__scroll-title').removeAttr('disabled');
  //                 $('.discount-footer__scroll-title').attr('placeholder', 'ایمیل را وارد کنید')
  //             }
  //             if (e.clientX <= 460) {
  //                 pos1 = pos3 - e.clientX;
  //                 pos3 = e.clientX;
  //                 // set the element's new position:
  //                 elmnt.style.left = (elmnt.offsetLeft - pos1) + "px";
  //             }

  //         }

  //         function closeDragElement() {
  //             /* stop moving when mouse button is released:*/
  //             document.onmouseup = null;
  //             document.onmousemove = null;
  //         }
  //     }

  // }

  $(
    ".site-footer__main .site-footer__main-item--first .title,.site-footer__main .site-footer__main-item--second .title"
  ).on("click", function () {
    if ($(window).width() < 768) {
      $(this).siblings("ul").toggleClass("active");
    }
  });

  $(".single-top__footer-cart-basket .plus").on("click", function () {
    let el_count = $(this).siblings(".count");
    let count = el_count.attr("data-count");
    count++;
    el_count.html(count);
    el_count.attr("data-count", count);
  });

  $(".single-top__footer-cart-basket .minus").on("click", function () {
    let el_count = $(this).siblings(".count");
    let count = el_count.attr("data-count");
    if (count > 1) {
      count--;
    }
    el_count.html(count);
    el_count.attr("data-count", count);
  });

  /* megamenu responsive */
  $(".site-header-responsive__menu").on("click", function (e) {
    e.stopPropagation();
    $(".mega-menu-site-responsive").toggleClass("active");
    $(".mask-shadow").toggleClass("active");
    $("body").toggleClass("overflow-none");
  });

  $(".mega-menu-site-responsive").on("click", function (e) {
    e.preventDefault();
    e.stopPropagation();
    $(this).parent().toggleClass("active");
    $(this).siblings("ul").slideToggle(500);
  });

  $(".mega-menu-site-responsive__header").on("click", function (e) {
    e.stopPropagation();
  });

  $(".mega-menu-site-responsive__search").on("click", function (e) {
    e.stopPropagation();
  });
  $("#res-menu-body").on("click", function (e) {
    e.stopPropagation();
  });

  $(
    ".mega-menu-site-responsive > .mega-menu-site-responsive__body ul > .menu-item-has-children > a"
  ).on("click", function (e) {
    // e.preventDefault();
    // $( this ).parent().toggleClass( 'active' );
  });

  $(".mega-menu-site-responsive .close, .mega-menu-site-responsive .mm-res__close").on("click", function (e) {
    e.preventDefault();
    e.stopPropagation();
    $(".mega-menu-site-responsive").removeClass("active");
    $(".mask-shadow").removeClass("active");
    $("body").removeClass("overflow-none");
  });

  /* footer accordion on mobile */
  $(document).on("click", ".site-footer__main-col:not(.site-footer__main-col--about):not(.site-footer__main-col--trust) .site-footer__col-title", function (e) {
    if (window.matchMedia("(max-width: 768px)").matches) {
      e.preventDefault();
      $(this).parent().toggleClass("is-open");
    }
  });

  /* mobile sidebar theme toggle */
  $(".mm-res__theme").on("click", function (e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    e.stopPropagation();
    var currentTheme = $("body").attr("data-theme") || "light";
    var nextTheme = currentTheme === "dark" ? "light" : "dark";

    $("body").attr("data-theme", nextTheme);
    $(".site-header__bottom__theme-switch").attr("data-current-theme", nextTheme);

    var date = new Date();
    date.setTime(date.getTime() + 12 * 60 * 60 * 1000);
    document.cookie = "theme=" + nextTheme + "; expires=" + date.toGMTString() + "; path=/";
    return false;
  });

  $(".mask-shadow").on("click", function () {
    $(".aside-panel-warapper").removeClass("active");
    $(".mega-menu-site-responsive").removeClass("active");
    $("body").removeClass("overflow-none");
    $(this).removeClass("active");
  });

  $(
    ".mega-menu-site-responsive > .mega-menu-site-responsive__body ul > .menu-item-has-children > ul"
  ).slideToggle(0);
  // $( '.mega-menu-site-responsive > .mega-menu-site-responsive__body ul > .menu-item-has-children > ul > li > ul' ).slideToggle( 0 );
  $(
    ".mega-menu-site-responsive > .mega-menu-site-responsive__body ul > .menu-item-has-children > a"
  ).on("click", function () {
    $(this).siblings("ul").slideToggle(500);
    $(this).parent().toggleClass("active");
  });

  $(
    ".mega-menu-site-responsive > ul > .menu-item-has-children > ul > li > a"
  ).on("click", function () {
    $(this).siblings("ul").slideToggle(500);
    $(this).parent().toggleClass("active");
  });

  $(".mega-menu-site-responsive__search form input").focusin(function () {
    $(this).siblings("label").addClass("active");
  });

  $(".mega-menu-site-responsive__search form input").focusout(function () {
    if ($(this).val() === "") {
      $(this).siblings("label").removeClass("active");
    }
  });

  $(".notification-cart__info-button .close").on("click", function (e) {
    e.preventDefault();
    $(this).parents(".notification-cart").slideUp(300);
  });

  $(".mega-menu-site-responsive__body li a").on("click", function (e) {
    if ($(this).parent().hasClass("active")) {
      $(this).parent().removeClass("active");
    } else {
      $(this).parent().addClass("active").siblings().removeClass("active");
    }
  });

  AOS.init();

  const lightbox = GLightbox();

  function countDownTimer() {
    var countDown = parseInt($(".circle-one").css("animation-duration"));
    var i = setInterval(function () {
      var b1 = $(".finish-buy-time__count-down .sec");
      var b2 = $(".finish-buy-time__count-down .minutes");

      if (countDown === 1) {
        clearInterval(i);
      }
      countDown--;

      //This section convert "seconds" to hour And minute And second
      var hour = Math.floor(countDown / 3600);
      var min = Math.floor((countDown % 3600) / 60);
      var sec = Math.floor((countDown % 3600) % 60);
      if (sec < 10) {
        sec = "0" + sec;
      }

      if (min < 10) {
        min = "0" + min;
      }

      b1.text(sec);
      b2.text(min);
    }, 1000);
  }

  countDownTimer();

  var extime = $(".get-code__time-numb").attr("data-extime");
  $(".get-code__time-numb")
    .countdown(extime)
    .on("update.countdown", function (event) {
      var format = "%M:%S";
      $(this).html(event.strftime(format));
    })
    .on("finish.countdown", function (event) {
      $(this).html("This offer has expired!");
    });

  $(".choose-account__accounts-item label").on("click", function () {
    $(this).parent(".choose-account__accounts-item").addClass("active");
    $(this).parents(".choose-account").addClass("choose");
  });

  $(".choose-account__accounts-item label .close").on("click", function (e) {
    e.stopPropagation();
    $(this).parents(".choose-account__accounts-item").removeClass("active"); //.parents('.choose-account__accounts-item').removeClass('active');
    $(this).parents(".choose-account").removeClass("choose");
  });

  $(document).on("change", '.file__choose input[type="file"]', function () {
    var $this = $(this),
      $wrapper = $this.closest(".file");
    if (this.files && this.files[0]) {
      var reader = new FileReader();
      reader.onload = function (e) {
        $wrapper.addClass("file--uploaded");
        $wrapper
          .find(".file__img")
          .html(
            '<img height="53px" src="' +
              e.target.result +
              '" alt=""><span class="file__img-remove"><i class="icon-close"></i>حذف</span>'
          );
      };
      reader.readAsDataURL(this.files[0]);
    }
  });

  $(document).on("click", ".file__img-remove", function () {
    var $this = $(this),
      $wrapper = $this.closest(".file");
    $wrapper.find(".file__img").html('<i class="icon-image"></i>');
    $wrapper.find('.file__choose input[type="file"]').val("");
  });

  $(document).on("click", ".item__copy-icon", function () {
    var text = $(this).siblings(".item__copy-code");
    copyToClipboard(text);
  });

  $(document).on("click", ".intro-link__copy-btn", function () {
    var text = $(this).siblings(".intro-link__copy-input");
    copyToClipboard(text);
  });

  $(document).on("click", "[data-copy]", function () {
    copyToClipboard($(this));
  });

  $(document).on("click", ".finish-buy__account-address .copy", function () {
    copyToClipboard(
      $(this).closest(".finish-buy__account-address").find(".copy-target")
    );
  });

  function copyToClipboard(element) {
    var $temp = $("<input>");
    $("body").append($temp);
    $temp.val($(element).text()).select();
    document.execCommand("copy");
    $temp.remove();
  }

  $(".get-code__inputs input").on("click", function (e) {
    $(this).focus().select();
  });

  $(".get-code__inputs input").on("keyup", function (e) {
    if (e.keyCode == 8 || e.keyCode == 46) {
      $(this).val("").prev("input").focus().select();
    } else {
      if ($(this).val().length == 1) {
        var $next = $(this).next("input");
        if ($next.length) $(this).next("input").focus();
        else $(this).blur();
      }
    }
  });

  $(".login__input.login__input--token input").on("click", function (e) {
    $(this).focus().select();
  });

  $(".login__input.login__input--token input").on("keyup", function (e) {
    if (e.keyCode == 8 || e.keyCode == 46) {
      $(this).val("").prev("input").focus().select();
    } else {
      if ($(this).val().length == 1) {
        var $next = $(this).next("input");
        if ($next.length) $(this).next("input").focus();
        else $(this).blur();
      }
    }
  });

  $(".login__input i.icon-eye").on("click", function () {
    $(this).siblings("input").attr("type", "text");
  });
  $(".plus_input").on("click", function () {
    let el = $(this).siblings(".count-product__count");
    let count = parseInt(el.val());
    count++;
    el.val(count);
  });

  $(".minus_input").on("click", function () {
    let el = $(this).siblings(".count-product__count");
    let count = parseInt(el.val());
    if (count > 1) {
      count--;
    }
    el.val(count);
  });

  $("#search_cat").on("keyup", function () {
    var $this = $(this);
    var filter_cat = $this.val();
    $(".single-top__item__product__type ul li").each(function (index) {
      var name_cat = $(this).find(".name_cat").text();
      if (name_cat.indexOf(filter_cat) >= 0)
        $(this).css("display", "list-item");
      else $(this).css("display", "none");
    });
  });

  Scrollbar.initAll();

  single_swiper = new Swiper(".single-top__swiper", {
    slidesPerView: 1.8,
    spaceBetween: 20,
    centeredSlides: 1,
    lazy: true,
    breakpoints: {
      992: {
        slidesPerView: 3.8,
        spaceBetween: 30,
      },
      768: {
        slidesPerView: 2.8,
        spaceBetween: 30,
      },
      576: {
        slidesPerView: 2.2,
        spaceBetween: 30,
      },
    },
    on: {
      init: function () {},
    },
  });

  if ($(".single-top__swiper").length > 0) {
    syncSinglePageSlider(0);
  }

  single_swiper.on("click", function () {
    syncSinglePageSlider(single_swiper.clickedIndex);
  });

  $(".single-top__price-type select").on("change", function (e) {
    var sel = parseInt($("option:selected", this).attr("data-select"));
    syncSinglePageSlider(sel, true, false);
  });

  $("#referral").on("change", function () {
    if ($(this).is(":checked")) {
      $(".login__input--referral-show").slideDown();
    } else {
      $(".login__input--referral-show").slideUp();
    }
  });

  //dark-mode

  let night = 17,
    day = 7;

  const getCookie = (cookieName) => {
    var name = cookieName + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  };

  const eraseCookie = (cookieName) => {
    document.cookie = cookieName + "=; Max-Age=-99999999;";
  };

  $(document).on(
    "click",
    ".site-header__bottom__theme-switch > div",
    function () {
      eraseCookie("locktheme");
      $(".site-header__bottom__theme-switch > svg").removeClass("active");
      let $this = $(this),
        remaining_hours,
        theme = $this.data("switch-theme"),
        date = new Date(),
        hours = date.getHours();

      $this.parent().attr("data-current-theme", theme);
      $("body").attr("data-theme", theme);
      if (hours >= night || hours < day) {
        remaining_hours = 24 - hours + day;
        remaining_hours =
          remaining_hours >= 24 ? remaining_hours - 24 : remaining_hours;
      } else if (hours >= day && hours < night) {
        remaining_hours = night - hours;
      }
      date.setTime(date.getTime() + remaining_hours * 60 * 60 * 1000);
      let expires = `; expires=${date.toGMTString()}`;
      document.cookie = `theme=${theme}${expires}`;
    }
  );

  $(document).on(
    {
      mouseenter: (e) => {
        let $this = $(e.currentTarget),
          title = $this.data("title");
        $this.siblings("span").html(title);
      },
    },
    ".site-header__bottom__theme-switch [data-title]"
  );

  const setTheme = (e) => {
    if (getCookie("theme") == "") {
      let date = new Date(),
        hours = date.getHours(),
        remaining_hours,
        expires,
        theme;

      if (hours >= night || hours < day) {
        remaining_hours = 24 - hours + day;
        remaining_hours =
          remaining_hours >= 24 ? remaining_hours - 24 : remaining_hours;
        date.setTime(date.getTime() + remaining_hours * 60 * 60 * 1000);
        expires = `; expires=${date.toGMTString()}`;
        theme = "dark";
      } else if (hours >= day && hours < night) {
        remaining_hours = night - hours;
        date.setTime(date.getTime() + remaining_hours * 60 * 60 * 1000);
        expires = `; expires=${date.toGMTString()}`;
        theme = "light";
      }
      document.cookie = `theme=${theme}${expires}`;
      $("body").attr("data-theme", theme);
      $(".site-header__bottom__theme-switch").attr("data-current-theme", theme);
    }
  };

  setTheme();

  $(document).on(
    "click",
    ".site-header__bottom__theme-switch > svg",
    function () {
      let $this = $(this),
        date = new Date(),
        current_theme = $this.parent().attr("data-current-theme");
      date.setTime(date.getTime() + 30 * 24 * 60 * 60 * 1000);
      let expires = `; expires=${date.toGMTString()}`;

      if ($this.hasClass("active")) {
        $this.removeClass("active");
        eraseCookie("theme");
        eraseCookie("locktheme");
      } else {
        $this.addClass("active");
        document.cookie = `theme=${current_theme}${expires}`;
        document.cookie = `locktheme=true${expires}`;
      }
    }
  );

  // (theme toggle handler now lives at the top of this file — see IIFE before $(document).ready)

  $(document).on("click", ".modal__content__add__title", function (e) {
    e.preventDefault();
    $(this).siblings(".modal__content__add__content").slideToggle();
  });

  /* (fab-contact toggle moved to top-level IIFE — see below) */
});

function syncSinglePageSlider(index, sliderUpdate = true, InputUpdate = true) {
  if (sliderUpdate) {
    $('.single-top__swiper .swiper-slide[data-select="' + index + '"]')
      .addClass("slide-active")
      .siblings()
      .removeClass("slide-active");
    single_swiper.slideTo(index);
  }
  if (InputUpdate) {
    $(
      '.single-top__price-type select option[data-select="' + index + '"]'
    ).prop("selected", true);
    $(".single-top__price-type .select-box").selectpicker("refresh");
  }
}

/**
 * ticker typing
 * @param {int} [typeSpeed] - Speed of typing.
 * @param {int} [delay] - delay in typing.
 */
$.fn.tickerTyping = function () {
  var typeSpeed = 30,
    delay = 2000,
    $this = $(this),
    $children = $this.children(),
    texts = $children
      .map(function () {
        return $(this).text();
      })
      .get();
  var i = 0,
    s = 0;
  var step = function () {
    var $current = $children.eq(i),
      $a = $current.find("a:first");
    $children.hide();
    $current.show();
    $a.text(texts[i].substr(0, s));
    if (s == texts[i].length) {
      s = 0;
      if (i == $children.length - 1) {
        i = 0;
      } else {
        i++;
      }
      setTimeout(step, delay);
    } else {
      setTimeout(step, typeSpeed);
    }
    s++;
  };
  step();
};

/**
 * generate tab
 * @param {string} [tabIndex] - The tabIndex is value of data-tabindex in parent tab.
 */
function tabInit(tabIndex) {
  if (typeof tabIndex === "undefined" || tabIndex === null) {
    $("[data-tabindex]").each(function () {
      let ele = $(this),
        dataTabindex = ele.attr("data-tabindex"),
        hasTrueTab = false;
      ele
        .find(' .tab-content [data-tabc][data-parent="' + dataTabindex + '"]')
        .hide();
      ele
        .find(' .tab-title  [data-tab][data-parent="' + dataTabindex + '"]')
        .each(function () {
          let i;
          if ($(this).hasClass("active")) {
            i = $(this).attr("data-tab");
            ele
              .find(
                '.tab-content [data-tabc="' +
                  i +
                  '"][data-parent="' +
                  dataTabindex +
                  '"]'
              )
              .addClass("active")
              .show();
            hasTrueTab = true;
          }
          if (hasTrueTab !== true) {
            ele
              .find(
                '.tab-content [data-tabc="' +
                  i +
                  '"][data-parent="' +
                  dataTabindex +
                  '"]:first-of-type'
              )
              .show();
            ele
              .find(
                '.tab-title [data-tab="' +
                  i +
                  '"][data-parent="' +
                  dataTabindex +
                  '"]:first-of-type'
              )
              .addClass("active");
          }
        });
      ele
        .find(' .tab-title [data-tab][data-parent="' + dataTabindex + '"]')
        .click(function () {
          if (!$(this).hasClass("active")) {
            let t = $(this).attr("data-tab"),
              oldActiveTab = ele
                .find(
                  ' .tab-title  [data-tab][data-parent="' +
                    dataTabindex +
                    '"].active'
                )
                .attr("data-tab");
            ele
              .find(
                " .tab-title  [data-tab=" +
                  oldActiveTab +
                  '][data-parent="' +
                  dataTabindex +
                  '"]'
              )
              .removeClass("active");
            ele
              .find(
                " .tab-content  [data-tabc=" +
                  oldActiveTab +
                  '][data-parent="' +
                  dataTabindex +
                  '"]'
              )
              .removeClass("active")
              .hide();
            $(this).addClass("active");
            ele
              .find(
                ' .tab-content  [data-tabc="' +
                  t +
                  '"][data-parent="' +
                  dataTabindex +
                  '"]'
              )
              .show();
          }
        });
    });
  } else {
    let dataTabindex = tabIndex;
    tabIndex = "[data-tabindex=" + tabIndex + "]";
    $(tabIndex)
      .find(' .tab-content [data-tabc][data-parent="' + dataTabindex + '"]')
      .hide();
    $(tabIndex)
      .find(' .tab-title [data-tab][data-parent="' + dataTabindex + '"]')
      .each(function () {
        var i;
        if ($(this).hasClass("active")) {
          i = $(this).attr("data-tab");
          $(tabIndex)
            .find(
              ' .tab-content  [data-tabc="' +
                i +
                '"][data-parent="' +
                dataTabindex +
                '"]'
            )
            .addClass("active")
            .show();
        }
      });
    $(tabIndex)
      .find(' .tab-title  [data-tab][data-parent="' + dataTabindex + '"]')
      .click(function () {
        if (!$(this).hasClass("active")) {
          let t = $(this).attr("data-tab"),
            oldActiveTab = $(tabIndex)
              .find(
                ' .tab-title  [data-tab][data-parent="' +
                  dataTabindex +
                  '"].active'
              )
              .attr("data-tab");
          $(tabIndex)
            .find(
              " .tab-title  [data-tab=" +
                oldActiveTab +
                '][data-parent="' +
                dataTabindex +
                '"]'
            )
            .removeClass("active");
          $(tabIndex)
            .find(
              " .tab-content  [data-tabc=" +
                oldActiveTab +
                '][data-parent="' +
                dataTabindex +
                '"]'
            )
            .removeClass("active")
            .hide();
          $(this).addClass("active");
          $(tabIndex)
            .find(
              ' .tab-content  [data-tabc="' +
                t +
                '"][data-parent="' +
                dataTabindex +
                '"]'
            )
            .show();
        }
      });
  }
  $("body").on("click", "[data-tabindex-current]", function () {
    let dataTabindex = $(this).attr("data-tabindex-current"),
      ele = $('[data-tabindex="' + dataTabindex + '"]'),
      tabCurrent = $(this).attr("data-tab-current");
    ele
      .find('.tab-title  [data-tab][data-parent="' + dataTabindex + '"]')
      .removeClass("active");
    ele
      .find('.tab-content  [data-tabc][data-parent="' + dataTabindex + '"]')
      .hide();
    ele
      .find(
        '.tab-title  [data-tab="' +
          tabCurrent +
          '"][data-parent="' +
          dataTabindex +
          '"]'
      )
      .addClass("active");
    ele
      .find(
        '.tab-content  [data-tabc="' +
          tabCurrent +
          '"][data-parent="' +
          dataTabindex +
          '"]'
      )
      .fadeIn();
  });
}

function numberWithCommas(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

/**
 *  block loader
 */
function blockLoader(status, element, title) {
  let loaderDom;
  if (typeof status === "undefined" || status === null) {
    status = "show";
  }
  if (typeof element === "undefined" || element === null) {
    element = "body";
  }
  if (typeof title === "undefined" || title === null) {
    title = "در حال بارگذاری ...";
  }
  loaderDom =
    '<div class="loader-overly"><div class="loader"><div class="spinner"><div></div><div></div><div></div><div></div></div>' +
    title +
    "</div>";
  let elementName = element;
  if (typeof element == "string") {
    element = $(element);
  }
  if (status == "show") {
    element.append(loaderDom);
    element.find(".loader-overly").show();
    if (elementName == "body") {
      element.addClass("loader-locked");
      element.find(".loader-overly").addClass("loader-overly_fixed");
    }
  } else {
    element.find(".loader-overly").hide();
    element.find(".loader-overly").remove();
    if (elementName == "body") {
      element.removeClass("loader-locked");
    }
  }
}

$.fn.extend({
  donetyping: function (callback, timeout) {
    timeout = timeout || 1e3; // 1 second default timeout
    var timeoutReference,
      doneTyping = function (el) {
        if (!timeoutReference) return;
        timeoutReference = null;
        callback.call(el);
      };
    return this.each(function (i, el) {
      var $el = $(el);
      // Chrome Fix (Use keyup over keypress to detect backspace)
      // thank you @palerdot
      $el.is(":input") &&
        $el
          .on("keyup keypress paste", function (e) {
            // This catches the backspace button in chrome, but also prevents
            // the event from triggering too preemptively. Without this line,
            // using tab/shift+tab will make the focused element fire the callback.
            if (e.type == "keyup" && e.keyCode != 8) return;

            // Check if timeout has been set. If it has, "reset" the clock and
            // start over again.
            if (timeoutReference) clearTimeout(timeoutReference);
            timeoutReference = setTimeout(function () {
              // if we made it here, our timeout has elapsed. Fire the
              // callback
              doneTyping(el);
            }, timeout);
          })
          .on("blur", function () {
            // If we can, fire the event since we're leaving the field
            doneTyping(el);
          });
    });
  },
});

/* serialize object */
$.fn.serializeObject = function () {
  "use strict";
  var a = {},
    b = function (b, c) {
      var d = a[c.name];
      "undefined" != typeof d && d !== null
        ? $.isArray(d)
          ? d.push(c.value)
          : (a[c.name] = [d, c.value])
        : (a[c.name] = c.value);
    };
  return $.each(this.serializeArray(), b), a;
};
/*
Replace all SVG images with inline SVG */
jQuery("img.svg").each(function () {
  var $img = jQuery(this);
  var imgID = $img.attr("id");
  var imgClass = $img.attr("class");
  var imgURL = $img.attr("src");

  jQuery.get(
    imgURL,
    function (data) {
      // Get the SVG tag, ignore the rest
      var $svg = jQuery(data).find("svg");

      // Add replaced image's ID to the new SVG
      if (typeof imgID !== "undefined") {
        $svg = $svg.attr("id", imgID);
      }
      // Add replaced image's classes to the new SVG
      if (typeof imgClass !== "undefined") {
        $svg = $svg.attr("class", imgClass + " replaced-svg");
      }

      // Remove any invalid XML tags as per http://validator.w3.org
      $svg = $svg.removeAttr("xmlns:a");

      // Replace image with new SVG
      $img.replaceWith($svg);
    },
    "xml"
  );
});

// map
function google_maps() {
  let divs = document.querySelectorAll(".google-map");
  let i = 0;
  if (divs.length) {
    Object.entries(divs).map((object) => {
      i++;
      let lat = parseFloat(object[1].getAttribute("data-lat"));
      let long = parseFloat(object[1].getAttribute("data-long"));
      let myLatLng = { lat: lat, lng: long };
      let data_id = "googlemap" + i;
      object[1].setAttribute("id", data_id);
      let mapProp = {
        center: new google.maps.LatLng(lat, long),
        zoom: 18,
      };

      let map = new google.maps.Map(document.getElementById(data_id), mapProp);
      let marker = new google.maps.Marker({
        position: myLatLng,
        map: map,
        draggable: true,
        animation: google.maps.Animation.DROP,
      });

      function toggleBounce() {
        if (marker.getAnimation() !== null) {
          marker.setAnimation(null);
        } else {
          marker.setAnimation(google.maps.Animation.BOUNCE);
        }
      }
    });
  }
}

$(".social-media__items a").on("mouseover", function () {
  $(this).addClass("active");
  var parent = $(this).parent(),
    data = parent.siblings().find("a");
  data.removeClass("active");
  data.find("span").css("display", "none");
  if ($(this).hasClass("active")) {
    $(this).find("span").css("display", "block");
  }
});

$(document).on("change", "#bug-file", (e) => {
  $("#bug-file-name").html(
    $(e.currentTarget)
      .val()
      .replace(/C:\\fakepath\\/i, "")
  );
});

function syncSinglePageSlider(index, sliderUpdate = true, InputUpdate = true) {
  $(".show_noti_text").hide();
  $("#show_noti_text_" + index).show();

  if (sliderUpdate) {
    $('.single-top__swiper .swiper-slide[data-select="' + index + '"]')
      .addClass("slide-active")
      .siblings()
      .removeClass("slide-active");
    single_swiper.slideTo(index);
  }
  if (InputUpdate) {
    $(
      '.single-top__price-type select option[data-select="' + index + '"]'
    ).prop("selected", true);

    $(".single-top__price-type .select-box").selectpicker("refresh");
  }
}
// function printdiv() {
//     var printContents = document.getElementById('print-this').innerHTML;

//     var originalContents = document.body.innerHTML;
//     document.body.innerHTML = printContents;
//     window.open();
//     window.print();
//     document.body.innerHTML = originalContents;
// }

function printdiv() {
  var mywindow = window.open("", "PRINT", "height=500,width=500");

  //Append the DIV contents.
  mywindow.document.write(
    `<html><head>${document.head.innerHTML}</head><body>${
      document.getElementById("print-this").innerHTML
    }</body></html>`
  );
  mywindow.document.close(); // necessary for IE >= 10
  mywindow.focus(); // necessary for IE >= 10*/

  setTimeout(() => {
    mywindow.print();
    // mywindow.close();
  }, 500);

  return true;
}
$(".aboutus__item__continue a").on("click", function () {
  var $this = $(this),
    parent = $this.parents(".aboutus__item"),
    sibl = parent.find(".aboutus__item__content");
  console.log(sibl);

  if (parent.hasClass("active")) {
    $(".aboutus__item__content").animate({ height: "225px" }, 500);
    parent.removeClass("active");
    $this.text("مشاهده بیشتر");
  } else {
    parent.addClass("active");
    $(".aboutus__item__content").animate({ height: "100%" }, 500);
    $this.text("بستن");
  }
});
$(document).on("click", ".single-top__item__product__type__item", function (e) {
  var $this = $(this),
    parent = $this.parent(),
    sibl = parent.siblings().find(".single-top__item__product__type__item"),
    mm = $this.find('input[name="category-radio"]');

  if ($this.hasClass("active")) {
    $this.removeClass("active");
    $this.find('input[name="category-radio"]').removeAttr("checked");
    mm.prop("checked", false);
  } else {
    $this.addClass("active");
    sibl.removeClass("active");
    mm.prop("checked", true);
  }
});

//*Single-Account*//
new Swiper(".context-account__gallery__slider__swiper", {
  slidesPerView: 2,
  spaceBetween: 9,
  lazy: true,
  // loop:true,
  // autoplay: {
  //     delay: 500,
  // },
  breakpoints: {
    992: {
      slidesPerView: 2,
      spaceBetween: 30,
    },
    768: {
      slidesPerView: 2,
      spaceBetween: 30,
    },
    576: {
      slidesPerView: 1.7,
      spaceBetween: 30,
    },
    450: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
    300: {
      slidesPerView: 2,
      spaceBetween: 12,
    },
  },
});

new Swiper(".swiper-account__swiper", {
  slidesPerView: 3,
  spaceBetween: 30,
  loop: true,
  lazy: true,

  // autoplay: {
  //     // autoplay:true,
  //     // delay: 3000,
  // },
  breakpoints: {
    992: {
      slidesPerView: 3,
      spaceBetween: 30,
    },
    768: {
      slidesPerView: 2,
      spaceBetween: 30,
    },
    576: {
      slidesPerView: 1.5,
      spaceBetween: 30,
    },
    450: {
      slidesPerView: 1,
      spaceBetween: 20,
    },
    300: {
      slidesPerView: 1,
      spaceBetween: 20,
    },
  },
});

$(".content-fq__content__title").on("click", function () {
  $(this)
    .parents(".content-fq__content ul li")
    .siblings()
    .find(".content-fq__content__text")
    .slideUp(300);
  $(this)
    .parents(".content-fq__content ul li")
    .siblings()
    .removeClass("active");
  if ($(this).parent().hasClass("active")) {
    $(this).parents(".content-fq__content ul li").removeClass("active");
    $(this).siblings(".content-fq__content__text").slideUp(300);
  } else {
    $(this).parents(".content-fq__content ul li").addClass("active");
    $(this).siblings(".content-fq__content__text").slideDown(300);
  }
});

// Upload image:

$(document).ready(function () {
  const img = document.getElementById("preview");
  const input = document.getElementById("picker");

  // بررسی وجود عنصر input
  if (input) {
    input.onchange = function (ev) {
      const file = ev.target.files[0];
      const blobURL = URL.createObjectURL(file);
      img.src = blobURL;
      img.style.display = "block"; // نمایش تصویر
      $("#remove").css("display", "block"); // نمایش دکمه حذف
    };

    $("#remove").click(function () {
      img.src = "#"; // یا یک مسیر پیش‌فرض خالی
      img.style.display = "none"; // مخفی کردن تصویر
      $("#remove").css("display", "none"); // مخفی کردن دکمه حذف
    });
  }
  $(document).ready(function () {
    $("#file-upload").on("change", function () {
      const fileInput = this;
      const fileNameDisplay = $("#file-name-display");
      const file = fileInput.files[0];

      if (file) {
        const fileName = file.name;
        const fileExtension = fileName.split(".").pop().toLowerCase();
        const allowedExtensions = ["jpg", "jpeg", "png"];
        console.log(file);
        if (allowedExtensions.includes(fileExtension)) {
          fileNameDisplay.text(fileName);
        } else {
          fileNameDisplay.text("پسوند نامعتبر است!");
          fileInput.value = "";
        }
      } else {
        fileNameDisplay.text("انـتـخــاب فــایــل");
      }
    });
  });
});

// ── Header user panel: dropdown toggle ────────────────────────
(function () {
  // For mobile (.mh) panels, the dropdown must be teleported to <body>
  // so it escapes the swiper/banner stacking contexts on the page.
  function lift(dd) {
    if (!dd || dd.dataset.lifted === "1") return;
    var panel = dd.closest(".sh-panel");
    if (!panel || !panel.classList.contains("mh__panel")) return;
    dd.dataset.lifted = "1";
    dd.dataset.ownerId = panel.id || (panel.id = "mh-panel-" + Math.random().toString(36).slice(2, 8));
    document.body.appendChild(dd);
    dd.classList.add("sh-panel__dropdown--lifted");
  }

  function findDropdown(panel) {
    var inside = panel.querySelector(".sh-panel__dropdown");
    if (inside) return inside;
    if (panel.id) {
      return document.querySelector('.sh-panel__dropdown[data-owner-id="' + panel.id + '"]');
    }
    return null;
  }

  document.addEventListener("click", function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    var btn = t.closest(".sh-panel__btn");
    if (btn) {
      var panel = btn.closest(".sh-panel");
      if (!panel) return;
      var dd = findDropdown(panel);
      if (!dd) return;
      lift(dd);
      var willOpen = !dd.classList.contains("is-open");
      dd.classList.toggle("is-open", willOpen);
      btn.setAttribute("aria-expanded", willOpen ? "true" : "false");
      return;
    }

    // Click outside any open panel → close it
    document.querySelectorAll(".sh-panel__dropdown.is-open").forEach(function (open) {
      // For lifted dropdowns, the click target needs to not be inside the dropdown itself
      // and not inside its owning panel.
      var ownerId = open.getAttribute("data-owner-id");
      var ownerPanel = ownerId ? document.getElementById(ownerId) : open.closest(".sh-panel");
      if (t.closest(".sh-panel__dropdown") === open) return;
      if (ownerPanel && t.closest(".sh-panel") === ownerPanel) return;
      open.classList.remove("is-open");
      var b = ownerPanel && ownerPanel.querySelector(".sh-panel__btn");
      if (b) b.setAttribute("aria-expanded", "false");
    });
  });

  // Esc closes
  document.addEventListener("keydown", function (e) {
    if (e.key !== "Escape") return;
    document.querySelectorAll(".sh-panel__dropdown.is-open").forEach(function (open) {
      open.classList.remove("is-open");
      var ownerId = open.getAttribute("data-owner-id");
      var ownerPanel = ownerId ? document.getElementById(ownerId) : open.closest(".sh-panel");
      var b = ownerPanel && ownerPanel.querySelector(".sh-panel__btn");
      if (b) b.setAttribute("aria-expanded", "false");
    });
  });
})();

// ── Header category chips: wheel scroll + prev/next arrows ───────
(function () {
  document.querySelectorAll(".sh-cats").forEach(function (strip) {
    // Vertical mouse wheel → horizontal scroll inside the strip
    strip.addEventListener("wheel", function (e) {
      var canScrollX = strip.scrollWidth > strip.clientWidth + 1;
      if (!canScrollX) return;
      if (Math.abs(e.deltaY) <= Math.abs(e.deltaX)) return;
      e.preventDefault();
      strip.scrollLeft += e.deltaY;
    }, { passive: false });
  });

  // Prev/Next arrow buttons
  document.querySelectorAll(".sh-cats-row").forEach(function (row) {
    var strip = row.querySelector(".sh-cats");
    var prev  = row.querySelector('[data-cats-scroll="prev"]');
    var next  = row.querySelector('[data-cats-scroll="next"]');
    if (!strip) return;

    function step(dir) {
      // Scroll one chip's-worth (~ chip width + gap) per click
      var sample = strip.querySelector(".sh-cat");
      var stepSize = sample
        ? sample.getBoundingClientRect().width + 8
        : Math.round(strip.clientWidth * 0.6);
      // RTL: in browser scrollLeft semantics, "next" in visual order may be negative
      var dirSigned = (getComputedStyle(strip).direction === "rtl") ? -dir : dir;
      strip.scrollBy({ left: stepSize * dirSigned, behavior: "smooth" });
    }

    if (prev) prev.addEventListener("click", function () { step(-1); });
    if (next) next.addEventListener("click", function () { step(+1); });

    // Reflect "edge reached" state on the arrows (disable when no more)
    function refreshEdges() {
      if (!prev && !next) return;
      var max = strip.scrollWidth - strip.clientWidth;
      var sl  = strip.scrollLeft;
      // RTL: scrollLeft can be 0 at start, negative going one way (Chrome/FF)
      // Normalize: distance from start = |sl|, distance to end = max - |sl|
      var fromStart = Math.abs(sl);
      var toEnd = Math.max(0, max - fromStart);
      var rtl = getComputedStyle(strip).direction === "rtl";
      // In RTL, "prev" arrow visually points right (going to start of list).
      // We treat "prev" as scrolling toward start (fromStart > 0 to be enabled).
      if (prev) prev.classList.toggle("is-disabled", fromStart < 2);
      if (next) next.classList.toggle("is-disabled", toEnd < 2);
      // Hide the whole row navs entirely if no overflow
      var canScroll = strip.scrollWidth > strip.clientWidth + 1;
      if (prev) prev.style.display = canScroll ? "" : "none";
      if (next) next.style.display = canScroll ? "" : "none";
    }

    strip.addEventListener("scroll", function () {
      requestAnimationFrame(refreshEdges);
    }, { passive: true });
    window.addEventListener("resize", refreshEdges);
    // Initial check after layout
    if (document.readyState === "complete") refreshEdges();
    else window.addEventListener("load", refreshEdges);
    refreshEdges();
  });
})();

// ── Sticky chip strip via fixed-position promotion ───────────────
// Switches `.site-header__bottom` to position:fixed when the user
// scrolls past its natural top. Bypasses any containing-block traps
// (backdrop-filter, transform) on ancestors that would otherwise
// break `position: sticky`.
(function () {
  var strip = document.querySelector(".site-header__bottom");
  var chips = document.querySelectorAll(".sh-cat[data-cat-target]");
  if (!strip || !chips.length) return;

  // Click → smooth-scroll to the target section + reveal next chip in strip
  chips.forEach(function (chip) {
    chip.addEventListener("click", function (e) {
      var targetId = chip.getAttribute("data-cat-target");
      var target = document.getElementById(targetId);
      if (!target) return;
      e.preventDefault();
      var offset = (strip.offsetHeight || 60) + 8;
      var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top: Math.max(0, top), behavior: "smooth" });

      // Reveal the chip after this one (so user knows there's "next")
      var stripBox = strip.querySelector(".sh-cats");
      if (!stripBox) return;
      // Use the *visual* next sibling chip in the flow direction
      var nextChip = chip.nextElementSibling;
      while (nextChip && !nextChip.classList.contains("sh-cat")) {
        nextChip = nextChip.nextElementSibling;
      }
      var anchor = nextChip || chip;
      // If anchor is fully outside the visible window, scroll so it sits near the edge
      var stripRect  = stripBox.getBoundingClientRect();
      var anchorRect = anchor.getBoundingClientRect();
      var pad = 12;
      // Visual right edge of strip in viewport — accounts for RTL too
      if (anchorRect.right > stripRect.right - pad) {
        stripBox.scrollBy({ left: anchorRect.right - stripRect.right + pad, behavior: "smooth" });
      } else if (anchorRect.left < stripRect.left + pad) {
        stripBox.scrollBy({ left: anchorRect.left - stripRect.left - pad, behavior: "smooth" });
      }
    });
  });

  // Placeholder to preserve layout when strip becomes fixed
  var placeholder = document.createElement("div");
  placeholder.className = "site-header__bottom-placeholder";
  placeholder.style.display = "none";
  if (strip.parentNode) strip.parentNode.insertBefore(placeholder, strip);

  // The natural top offset of the strip in the page
  function naturalTop() {
    if (strip.classList.contains("sh-cats-stuck")) {
      // already fixed — use placeholder position
      return placeholder.getBoundingClientRect().top + window.pageYOffset;
    }
    return strip.getBoundingClientRect().top + window.pageYOffset;
  }

  var stuckTop = naturalTop();
  var stripHeight = strip.offsetHeight || 60;

  function recalc() {
    if (!strip.classList.contains("sh-cats-stuck")) {
      stuckTop = strip.getBoundingClientRect().top + window.pageYOffset;
      stripHeight = strip.offsetHeight || 60;
    }
  }
  // Recalc on resize
  window.addEventListener("resize", recalc);
  // Initial calc after layout
  if (document.readyState === "complete") recalc();
  else window.addEventListener("load", recalc);

  function onScroll() {
    var y = window.pageYOffset || document.documentElement.scrollTop;
    var shouldStick = y >= stuckTop - 0.5;
    if (shouldStick && !strip.classList.contains("sh-cats-stuck")) {
      placeholder.style.display = "block";
      placeholder.style.height = stripHeight + "px";
      strip.classList.add("sh-cats-stuck");
    } else if (!shouldStick && strip.classList.contains("sh-cats-stuck")) {
      strip.classList.remove("sh-cats-stuck");
      placeholder.style.display = "none";
    }
  }

  // rAF-throttled scroll handler
  var ticking = false;
  window.addEventListener("scroll", function () {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      onScroll();
      ticking = false;
    });
  }, { passive: true });
  onScroll();

  // Active-section highlight via IntersectionObserver
  if ("IntersectionObserver" in window) {
    var sections = [];
    chips.forEach(function (chip) {
      var id = chip.getAttribute("data-cat-target");
      var sec = document.getElementById(id);
      if (sec && sections.indexOf(sec) === -1) sections.push(sec);
    });

    if (sections.length) {
      var sectObs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var id = entry.target.id;
          chips.forEach(function (c) {
            var match = c.getAttribute("data-cat-target") === id;
            c.classList.toggle("is-active", match);
            if (match) {
              var stripBox = strip.querySelector(".sh-cats");
              if (stripBox && c.offsetParent) {
                var chipLeft = c.offsetLeft;
                var chipRight = chipLeft + c.offsetWidth;
                var viewLeft = stripBox.scrollLeft;
                var viewRight = viewLeft + stripBox.clientWidth;
                if (chipLeft < viewLeft || chipRight > viewRight) {
                  stripBox.scrollTo({
                    left: chipLeft - (stripBox.clientWidth - c.offsetWidth) / 2,
                    behavior: "smooth"
                  });
                }
              }
            }
          });
        });
      }, {
        rootMargin: "-" + (stripHeight + 20) + "px 0px -55% 0px",
        threshold: 0
      });
      sections.forEach(function (s) { sectObs.observe(s); });
    }
  }
})();

// ── Mega menu: click to open/close, click outside to close ───────
(function () {
  function closeAll(except) {
    document.querySelectorAll(".sh-nav__cat.is-open").forEach(function (c) {
      if (c !== except) c.classList.remove("is-open");
    });
  }

  document.addEventListener("click", function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    // Click on the category trigger button → toggle its parent
    var btn = t.closest(".sh-nav__cat-btn");
    if (btn) {
      var cat = btn.closest(".sh-nav__cat");
      if (!cat) return;
      e.preventDefault();
      e.stopPropagation();
      var willOpen = !cat.classList.contains("is-open");
      closeAll(willOpen ? cat : null);
      cat.classList.toggle("is-open", willOpen);
      btn.setAttribute("aria-expanded", willOpen ? "true" : "false");
      return;
    }

    // Clicked inside an open mega menu — keep it open
    if (t.closest(".sh-nav__megamenu")) return;

    // Click outside any open category → close all
    closeAll(null);
  });

  // Esc closes everything
  document.addEventListener("keydown", function (e) {
    if (e.key !== "Escape") return;
    closeAll(null);
  });
})();

// ── AI products: save/favorite toggle on cards ────────────────
(function () {
  document.addEventListener("click", function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var btn = t.closest(".ai-products__card-save");
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    btn.classList.toggle("active");
  });
})();
